import { getLenisScroll } from "./lenis-scroll";

function getLenisConstructor() {
	return window.Lenis || globalThis.Lenis;
}

export function jcfReplace(d){
	jcf.replace(jQuery('#viewport input[type="checkbox"]'));
	jcf.replace(jQuery('#viewport input[type="radio"]'));
	var customSelect = jQuery('#viewport select').not('.lang select');

	jcf.setOptions('Select', {
		wrapNative: false,
		wrapNativeOnMobile: false,
		fakeDropInBody: false,
		maxVisibleItems: 4,
		useCustomScroll:false,
	});

	jcf.replace(customSelect);

	d.querySelectorAll('.jcf-checkbox input[type="checkbox"][disabled]').forEach(input => {
		
		input.closest('.jcf-checkbox').classList.add('disabled');
		
	});
	
	
	let selects = d.querySelectorAll('.jcf-select');
	selects.forEach(function (select) {
		select.addEventListener("click", ()=>{
			const LenisConstructor = getLenisConstructor();

			if(select.querySelector('.jcf-list-content') && LenisConstructor) {
				
				let lenis = new LenisConstructor({
					lerp: 0.1,
					duration: 1.8,
					wrapper: select.querySelector('.jcf-list-content'),
					smooth: true,
					//infinite:true,
					content: select.querySelector('.jcf-list-content'),
				});

				lenis.on('scroll', ScrollTrigger.update);

				gsap.ticker.add(time => {
					lenis.raf(time * 1000);
				});

				gsap.ticker.lagSmoothing(0);
			}
			
			
		});
		
	});

	

	


	



	
}
